import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/auth/authentication/authentication.service';

@Component({
  selector: 'mtn-log-out-handler',
  standalone: true,
  imports: [],
  templateUrl: './log-out-handler.component.html',
  styleUrl: './log-out-handler.component.scss'
})
export class LogOutHandlerComponent implements OnInit {
  constructor(
    private readonly authenticationService: AuthenticationService,
    private readonly router: Router,
    private readonly route: ActivatedRoute
  ) {}

ngOnInit(): void {
  document.body.style.backgroundColor = 'white';

  const returnTo = this.route.snapshot.queryParamMap.get('returnTo');
  this.authenticationService.clearAuthentication();

  if (returnTo) {
    window.location.href = returnTo; // full reload – resets styles
  } else {
    this.router.navigate(['/']); // Angular route – styles reset
  }
}


}
